import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab, useTheme } from '@mui/material';
import MyHeadings from '../../Vendor-ui/Headings';
import { approvalProducts } from '../../../../../services/api/ProductAPI';
import ProductTable from './ProductTable';

export default function VendorProductTable() {
	const theme = useTheme();

	const [tabIndex, setTabIndex] = useState(0);
	const [searchTerm, setSearchTerm] = useState('');
	const [approvedProducts, setApprovedProducts] = useState<any[]>([]);
	const [underReview, setUnderReview] = useState<any[]>([]);

	const fetchProducts = async () => {
		try {
			const response = await approvalProducts();
			if (response.success && response.data?.approved?.products) {
				const mappedApproved = response.data.approved.products.map((v: any) => ({
					id: v.productId || v._id,
					company: v.createdBy?.companyName || '-',
					contactPerson: v?.createdBy?.companyType || '-',
					contactEmail: v?.createdBy?.email || '-',
					phone: v?.createdBy?.mobile || '-',
					businessType: v?.createdBy?.companyType || '-',
					name: v.name || '-',
					price: v.price || 0,
					status: v.status === '1' ? 'Active' : 'Inactive',
					submitted: new Date(v.createdAt).toLocaleDateString('en-GB'),
					rawDate: new Date(v.createdAt),
					_id: v._id,
					slug: v.slug,
					createdByModel: v.createdByModel,
					productApprovelStatus: v.productApprovelStatus,
					vendorPercentage: v.vendorPercentage,
				}));
				setApprovedProducts(mappedApproved);
			} else {
				setApprovedProducts([]);
			}

			if (response.success && response.data?.underReview?.products) {
				const mappedReview = response.data.underReview.products.map((v: any) => ({
					id: v.productId || v._id,
					company: v.createdBy?.companyName || '-',
					contactPerson: v?.createdBy?.companyType || '-',
					contactEmail: v?.createdBy?.email || '-',
					phone: v?.createdBy?.mobile || '-',
					businessType: v?.createdBy?.companyType || '-',
					name: v.name || '-',
					price: v.price || 0,
					status: v.status === '1' ? 'Active' : 'Inactive',
					submitted: new Date(v.createdAt).toLocaleDateString('en-GB'),
					rawDate: new Date(v.createdAt),
					_id: v._id,
					slug: v.slug,
					createdByModel: v.createdByModel,
					productApprovelStatus: v.productApprovelStatus,
					vendorPercentage: v.vendorPercentage,
				}));
				setUnderReview(mappedReview);
			} else {
				setUnderReview([]);
			}
		} catch (error) {
			console.error('Error fetching products:', error);
			setApprovedProducts([]);
			setUnderReview([]);
		}
	};

	useEffect(() => {
		fetchProducts();
	}, []);

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setTabIndex(newValue);
	};

	return (
		<Box>
			<MyHeadings Title="Vendor Products" subtitle="Manage your Vendor/Admin products" />

			<Box sx={{ mb: 2 }}>
				<Tabs
					value={tabIndex}
					onChange={handleChange}
					variant="scrollable"
					TabIndicatorProps={{
						style: {
							backgroundColor: 'green',
							height: 3,
							borderRadius: 2,
						},
					}}
					sx={{
						'.MuiTab-root': {
							textTransform: 'none',
							fontWeight: 600,
							color: 'gray',
							px: 3,
						},
						'.Mui-selected': {
							color: 'green',
						},
					}}
				>
					<Tab label="Request Product" />
					<Tab label="Approval Product" />
				</Tabs>
			</Box>

			{/* ✅ Tab panels */}
			{tabIndex === 0 && (
				<ProductTable
					theme={theme}
					requests={underReview}
					searchTerm={searchTerm}
					setSearchTerm={setSearchTerm}
					fetchProducts={fetchProducts}
				/>
			)}
			{tabIndex === 1 && (
				<ProductTable
					theme={theme}
					requests={approvedProducts}
					searchTerm={searchTerm}
					setSearchTerm={setSearchTerm}
					fetchProducts={fetchProducts}
				/>
			)}
		</Box>
	);
}
